import React from "react";

import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  InputGroup,
  Input,
  InputGroupAddon,
  InputGroupText,
  FormGroup
} from "reactstrap";
import { bindActionCreators } from "redux";

import { logout, changeRoles } from "../../actions/baseActions";
import URL from "../../config/api";
import axios from "../../config/axios";
import Loading from "../Loading";

import "./modalGroup.css";

class modalGroupRegion extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: this.props.modalState,
      loading: true,
      // groupLoaded: false,
      active_roles: {},
      groupSelected: "",
      regionSelected: "",
      schoolSelected: "",
      // startFunctionTriggered: false,
      role: [],
      group: [],
      region: [],
      scholl: [],
      userSchools: [], // NOVO: array com todas as escolas do usuário
      userSchoolsLoaded: false,
      user_id: this.props.user.user.id
    };

    this.toggle = this.toggle.bind(this);
    this.getGroup = this.getGroup.bind(this);
    this.selectGroup = this.selectGroup.bind(this);
  }

  startFunction() {
    this.setState(
      {
        // startFunctionTriggered: true
      },
      () => {
        this.getUserSchools(() => {
          // NOVO: Primeiro busca as escolas do usuário
          this.getRole(() => {
            this.selectRole({
              target: { value: this.props.general.active_roles }
            });
          });
        });
      }
    );
  }

  componentDidMount() {
    this.startFunction();
  }

  getUserSchools = (callback = () => null) => {
    axios
      .get(`${URL.api}access/user/singleView/${this.state.user_id}`, {
        headers: { authorization: `Bearer ${this.props.user.token}` }
      })
      .then(
        resp => {
          if (resp.data.success) {
            // Extrai todos os school_id únicos do array user_role
            const userSchoolsIds = [
              ...new Set(resp.data.data.user_role.map(role => role.school_id))
            ];

            this.setState({
              userSchools: userSchoolsIds,
              userSchoolsLoaded: true
            });
          }
          callback();
        },
        error => {
          toastr.error(
            "Erro",
            "Não foi possível carregar as escolas do usuário"
          );
          callback();
        }
      );
  };

  updateRole() {
    this.getGroup(() => {
      if (this.state.active_roles.group_id) {
        this.selectGroup(
          { target: { value: this.state.active_roles.group_id } },
          () => {
            if (this.state.active_roles.region_id) {
              this.selectRegion(
                { target: { value: this.state.active_roles.region_id } },
                () => {
                  if (this.state.active_roles.school_id) {
                    this.selectScholl({
                      target: { value: this.state.active_roles.school_id }
                    });
                  }
                }
              );
            }
          }
        );
      }
    });
  }

  getRole = (callback = () => null) => {
    this.setState(
      {
        role: this.props.user.user_roles.map(roles => ({
          role_id: roles.role_id,
          role_name: roles.role_name,
          group_id: roles.group_id,
          group_name: roles.group_name,
          region_id: roles.region_id,
          region_name: roles.region_name,
          school_id: roles.school_id,
          school_name: roles.school_name,
          type: roles.type
        }))
      },
      callback
    );
  };

  equalsReturn(x, e) {
    return x.role_id === parseInt(e.target.value);
  }

  preSelectRole = e => {
    this.selectRole({
      target: {
        value: this.props.user.user_roles.find(item => {
          let x = `${item.role_id}-${
            item.school_name ? item.school_name : "null"
          }`;
          return x === e.target.value;
        })
      }
    });
  };

  selectRole = (e, callback = () => null) => {
    const event = e.target.value;
    this.setState(
      {
        group: [],
        region: [],
        scholl: [],
        // roleSelected: null,
        groupSelected: null,
        regionSelected: null,
        schoolSelected: null
      },
      () => {
        this.setState(
          state => ({ active_roles: event }),
          () => {
            this.updateRole();
          }
        );
      }
    );
  };

  getGroup = (callback = () => null) => {
    axios
      .get(`${URL.api}access/group/list`, {
        headers: { authorization: `Bearer ${this.props.user.token}` }
      })
      .then(
        resp => {
          if (resp.data.success) {
            this.setState({
              group: resp.data.data,
              loading: false
              // groupLoaded: true
            });
          }
          callback();
        },
        error => {
          toastr.error("Desconectado", "Sua sessão de acesso expirou");
          let { token } = this.props.user;
          this.props.logout(token);
        }
      );
  };

  selectGroup = (e, callback = () => null) => {
    const event = e.target.value;

    this.setState(
      {
        region: [],
        scholl: [],
        groupSelected: null,
        regionSelected: null,
        schoolSelected: null
      },
      () => {
        let groupSelected = "";
        if (
          this.state.groupSelected !== "" &&
          this.state.groupSelected !== null
        ) {
          groupSelected = this.state.groupSelected;
        } else {
          groupSelected = event;
        }
        axios
          .get(`${URL.api}access/region/listRegionFilter/${groupSelected}`, {
            headers: { authorization: `Bearer ${this.props.user.token}` }
          })
          .then(
            resp => {
              if (resp.data.success) {
                this.setState({
                  region: resp.data.data,
                  loading: false,
                  groupSelected
                });
              }
              callback();
            },
            error => {
              if (error.response === "Unauthorized") {
                this.props.logout(this.props.user.token);
              }
            }
          );
      }
    );
  };

  selectRegion = (e, callback = () => null) => {
    const event = e.target.value;
    this.setState(
      {
        scholl: [],
        regionSelected: null,
        schoolSelected: null
      },
      () => {
        let regionSelected = "";
        if (
          this.state.regionSelected !== "" &&
          this.state.regionSelected !== null
        ) {
          regionSelected = this.state.regionSelected;
        } else {
          regionSelected = event;
        }

        axios
          .get(
            `${URL.api}access/school/listSchoolByUserFilter/${this.state.groupSelected}/${regionSelected}`,
            { headers: { authorization: `Bearer ${this.props.user.token}` } }
          )
          .then(
            resp => {
              if (resp.data.success) {
                // SEMPRE aplicar o filtro se userSchools existir
                let schoolsToShow = resp.data.data;

                // Se temos as escolas do usuário, filtrar
                if (
                  this.state.userSchools &&
                  this.state.userSchools.length > 0
                ) {
                  // Converter ambos para string para garantir match
                  const userSchoolIds = this.state.userSchools.map(id =>
                    id.toString()
                  );
                  schoolsToShow = resp.data.data.filter(school =>
                    userSchoolIds.includes(school.id.toString())
                  );
                }

                this.setState({
                  scholl: schoolsToShow,
                  loading: false,
                  regionSelected
                });
              }
              callback();
            },
            error => {
              if (error.response === "Unauthorized") {
                this.props.logout(this.props.user.token);
              }
            }
          );
      }
    );
  };

  selectScholl = (e, callback = () => null) => {
    let schoolSelected = e.target.value;
    this.setState({
      schoolSelected
    });
    callback();
  };

  toggle() {
    this.setState(prevState => ({
      modal: !prevState.modal
    }));
  }

  submit = () => {
    let groupId = parseInt(this.state.groupSelected);
    let regionId = parseInt(this.state.regionSelected);
    let schoolId = parseInt(this.state.schoolSelected);

    if (!groupId || groupId === 0) {
      groupId = null;
    } else {
      this.setState(prevState => ({
        modal: this.props.modalState,
        loading: false,
        // eslint-disable-next-line react/no-access-state-in-setstate
        group: this.state.group,
        groupSelected: groupId
      }));
    }
    if (!regionId || regionId === 0) {
      regionId = null;
    } else {
      this.setState(prevState => ({
        modal: this.props.modalState,
        loading: false,
        // eslint-disable-next-line react/no-access-state-in-setstate
        region: this.state.region,
        // eslint-disable-next-line react/no-access-state-in-setstate
        regionSelected: this.state.regionSelected
      }));
    }
    if (!schoolId || schoolId === 0) schoolId = null;

    let groupName =
      this.state.group && this.state.group.find(item => item.id === groupId)
        ? this.state.group.find(item => item.id === groupId).name
        : null;
    let regionName =
      this.state.region && this.state.region.find(item => item.id === regionId)
        ? this.state.region.find(item => item.id === regionId).name
        : null;
    let schoolName =
      this.state.scholl && this.state.scholl.find(item => item.id === schoolId)
        ? this.state.scholl.find(item => item.id === schoolId).name
        : null;

    let roles = {
      role_id: this.state.active_roles.role_id,
      role_name: this.state.active_roles.role_name,
      group_id: groupName ? groupId : null,
      group_name: groupName,
      region_id: regionName ? regionId : null,
      region_name: regionName,
      school_id: schoolName ? schoolId : null,
      school_name: schoolName,
      type: this.state.active_roles.type
    };

    this.props.changeRoles(roles);
    // this.setState(prevState => ({
    //   modal: this.props.modalState,
    //   loading: false,
    //   group: this.state.group,
    // }));
    this.props.toggleModal();
  };

  render() {
    return (
      <div>
        <Modal
          isOpen={this.props.modalState}
          toggle={this.props.toggleModal}
          className={this.props.className}
        >
          <ModalHeader toggle={this.props.toggleModal}>
            {this.props.title}
          </ModalHeader>
          <ModalBody>
            {this.state.loading ? (
              <Loading />
            ) : (
              <form>
                <FormGroup className="">
                  <InputGroup>
                    <InputGroupAddon addonType="prepend">
                      <InputGroupText>
                        <span htmlFor="role">Perfil</span>
                      </InputGroupText>
                    </InputGroupAddon>
                    <Input
                      name="role"
                      type="select"
                      value={`${this.state.active_roles.role_id}-${this.state.active_roles.school_name}`}
                      onChange={this.preSelectRole}
                    >
                      {this.state.role.map((elem, idx) => (
                        <option
                          key={idx + 1}
                          value={`${elem.role_id}-${elem.school_name}`}
                        >
                          {elem.role_name}
                        </option>
                      ))}
                    </Input>
                  </InputGroup>
                </FormGroup>
                <FormGroup className="">
                  <InputGroup>
                    <InputGroupAddon addonType="prepend">
                      <InputGroupText>
                        <span htmlFor="group">Grupo</span>
                      </InputGroupText>
                    </InputGroupAddon>
                    <Input
                      name="group"
                      type="select"
                      value={
                        this.state.groupSelected ? this.state.groupSelected : 0
                      }
                      onChange={this.selectGroup}
                      disabled={["U", "R", "E", "P", "A", "S"].includes(
                        this.state.active_roles.type
                      )}
                    >
                      <option key="0" value="0">
                        Todos
                      </option>
                      {this.state.group.map((elem, idx) => (
                        <option key={idx + 1} value={elem.id}>
                          {elem.name}
                        </option>
                      ))}
                    </Input>
                  </InputGroup>
                </FormGroup>
                {this.state.groupSelected &&
                  !["", "0"].includes(this.state.groupSelected) && (
                    <>
                      <FormGroup className="">
                        <InputGroup>
                          <InputGroupAddon addonType="prepend">
                            <InputGroupText>
                              <span htmlFor="region">Região</span>
                            </InputGroupText>
                          </InputGroupAddon>
                          <Input
                            name="region"
                            type="select"
                            onChange={this.selectRegion}
                            value={
                              this.state.regionSelected
                                ? this.state.regionSelected
                                : 0
                            }
                            disabled={["R", "E", "P", "A", "S"].includes(
                              this.state.active_roles.type
                            )}
                          >
                            <option key="0" value="0">
                              Todas
                            </option>
                            {this.state.region.map((elem, idx) => (
                              <option key={idx + 1} value={elem.id}>
                                {elem.name}
                              </option>
                            ))}
                          </Input>
                        </InputGroup>
                      </FormGroup>
                      {this.state.regionSelected &&
                        !["", "0"].includes(this.state.regionSelected) && (
                          <FormGroup className="">
                            <InputGroup>
                              <InputGroupAddon addonType="prepend">
                                <InputGroupText>
                                  <span htmlFor="scholl">Escola</span>
                                </InputGroupText>
                              </InputGroupAddon>
                              <Input
                                name="scholl"
                                type="select"
                                onChange={this.selectScholl}
                                value={
                                  this.state.schoolSelected
                                    ? this.state.schoolSelected
                                    : 0
                                }
                              >
                                {this.state.scholl.map((elem, idx) => (
                                  <option key={idx + 1} value={elem.id}>
                                    {elem.name}
                                  </option>
                                ))}
                              </Input>
                            </InputGroup>
                          </FormGroup>
                        )}
                    </>
                  )}
              </form>
            )}
          </ModalBody>
          <ModalFooter>
            <Button color="primary" onClick={this.submit}>
              Salvar
            </Button>
            <Button
              color="secondary"
              onClick={() => this.props.toggleModal(false)}
            >
              Cancelar
            </Button>
          </ModalFooter>
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  form: state.form,
  general: state.general
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      logout,
      changeRoles
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(modalGroupRegion);
